window.conergiesCursorFrameTargets = [
  '.custom-button',
  // '.ai-icon-button-avdzjqvjhywzdve1ryaigenblockf797181yrlqnt',
  // '.ai-icon-button-atfm2wk9ikzfpcnj4zaigenblockf797181jnduic',
  // '.ai-icon-button-aqmf4nwjdqjfcvfpheaigenblockf797181jyejww',
  // '.ai-icon-button-an09jk0xvwjlizkdquaigenblockf79718139rwfv',
  // '.ai-icon-button-auje5wlp2q0zwn1kyraigenblockf797181qlrahw',
  // '.ai-icon-button-aetfrsupuqi8ws2s2oaigenblockf797181tkl7dy',
  // '.ai-icon-button-link-awmtzmzfrwxcymmswuaigenblockf797181qvamyh',
  '#shopify-block-Aa1NqT0lpRFBBSzY1S__ai_gen_block_f797181_yrLqNT',
  '.conergies-footer-social a',
  '.conergies-footer-dealer',
  '.conergies-footer-email',
  '.conergies-footer-software',
  '.conergies-footer-mark',
  '.header-logo__image',
];

window.conergiesCursorNativeTargets = [
  // '.example-native-cursor-target',
  ".Avada-Preview_Popup.Joy-WidgetVer3",
  "#shopify-section-template--21690105233605__section_BC8ztc .layout-panel-flex",
  "#ShopifyChat",
  "#quick-add-dialog",
  ".facets__filters-wrapper",
  ".cart-drawer__inner",
  ".predictive-search-form",
];

window.conergiesCursorFrameClassPrefixes = [
  //'ai-icon-button-',
];

window.conergiesCursorFrameIdPrefixes = [
  //'shopify-block-',
];
